
import HotDropdownNormalContent from '~/components/Molecules/DropdownNormalContent/DropdownNormalContent.vue'
import HotDropdownGroupsContent from '~/components/Molecules/DropdownGroup/DropdownGroupsContent.vue'

export default {
  name: 'HotDropdown',

  components: {
    HotDropdownNormalContent,
    HotDropdownGroupsContent,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    navigation: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'megamenu',
      validator: value => ['simple', 'megamenu', 'normal'].includes(value),
    },
    setButtonStyle: {
      type: Boolean,
      default: false,
    },
    setLinkStyle: {
      type: Boolean,
      default: true,
    },
    submenu: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: 'chevronDown',
    },
    menuData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isActive: false,
    }
  },

  computed: {
    dropdownClasses() {
      return [
        'dropdown-trigger',
        {
          menu__link: this.setLinkStyle,
          'button button--tertiary with--icon': this.setButtonStyle,
          'link link--primary': !this.setButtonStyle,
          'menu__link--isOpen': this.isActive,
        },
      ]
    },

    iconMenuClasses() {
      return ['menu__icon', { 'menu__icon--rotated': this.isActive }]
    },

    contentClasses() {
      return [
        'dropdown__content',
        `type--${this.type}`,
        {
          'dropdown--open': this.isActive,
          'dropdown--closed': !this.isActive,
        },
      ]
    },
  },

  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },

  beforeDestroy() {
    this.removeOutsideClickListener()
  },

  methods: {
    dropdownEvent() {
      this.isActive = !this.isActive
      this.$emit('toggle', { id: this.id, isActive: this.isActive })

      if (this.menuData && Object.keys(this.menuData).length) {
        const event = new CustomEvent('dropdown:toggle', {
          detail: { menuData: this.menuData, id: this.id, isActive: this.isActive },
        })
        window.dispatchEvent(event)
      }
    },

    handleOutsideClick(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.isActive = false
      }
    },

    removeOutsideClickListener() {
      document.removeEventListener('click', this.handleOutsideClick)
    },
  },
}
